import React, { useEffect, useState } from 'react';
import './TermsAndConditions.css';

const LAST_UPDATED = '6 ოქტომბერი, 2026';

const facts = [
  { big: '2 დღე', small: 'დაბრუნებისთვის' },
  { big: '1–2 დღე', small: 'თბილისში მიწოდება' },
  { big: '₾ + დღგ', small: 'ფასები ლარში, დღგ-ს ჩათვლით' },
];

const sections = [
  {
    id: 'general',
    title: 'ზოგადი დებულებები',
    items: [
      'წინამდებარე წესები და პირობები არეგულირებს Kido-ს (შემდგომში „მაღაზია“) ვებგვერდზე ბავშვთა ტანსაცმლისა და აქსესუარების შეძენას.',
      'ვებგვერდით სარგებლობით ან შეკვეთის გაფორმებით თქვენ ადასტურებთ, რომ გაეცანით ამ პირობებს და ეთანხმებით მათ.',
      'შეკვეთის გაფორმება შეუძლია მხოლოდ სრულწლოვან პირს (18 წლის ასაკიდან).',
    ],
  },
  {
    id: 'order',
    title: 'შეკვეთის გაფორმება',
    items: [
      'შეკვეთის გასაფორმებლად აირჩიეთ პროდუქცია, მიუთითეთ ზომა და რაოდენობა, შეავსეთ მიწოდების მონაცემები და დაადასტურეთ შეკვეთა.',
      'შეკვეთის გაფორმებისთანავე მიიღებთ დადასტურებას მითითებულ ელფოსტაზე ან ტელეფონის ნომერზე.',
      'თუ შეკვეთილი პროდუქცია მარაგში აღარ არის, დაგიკავშირდებით და შემოგთავაზებთ შესაფერის ალტერნატივას ან გადახდილი თანხის სრულ დაბრუნებას.',
    ],
  },
  {
    id: 'price',
    title: 'ფასები და გადახდა',
    items: [
      'ყველა ფასი მითითებულია ლარში (₾) და მოიცავს დღგ-ს.',
      'ფასები და აქციები შეიძლება შეიცვალოს წინასწარი გაფრთხილების გარეშე. შეკვეთის დადასტურების მომენტში მითითებული ფასი აღარ იცვლება.',
      'გადახდა შესაძლებელია საბანკო ბარათით ონლაინ ან ნაღდი ანგარიშსწორებით მიწოდებისას.',
      'ბარათით გადახდა მუშავდება ბანკის დაცული სისტემით. მაღაზია თქვენი ბარათის მონაცემებს არ ინახავს.',
    ],
  },
  {
    id: 'delivery',
    title: 'მიწოდება',
    items: [
      'თბილისში შეკვეთა მიწოდებულია 1–2 სამუშაო დღეში, ხოლო საქართველოს რეგიონებში 2–5 სამუშაო დღეში.',
      'მიწოდების ღირებულება ჩანს შეკვეთის გაფორმებისას და ემატება შეკვეთის თანხას.',
      'შეკვეთის მიღებისას, კურიერის თანდასწრებით, გადაამოწმეთ შეფუთვისა და პროდუქციის მდგომარეობა. დაზიანების შემთხვევაში დაუყოვნებლივ შეგვატყობინეთ.',
      'მითითებული ვადები ორიენტაციულია და შეიძლება გაიზარდოს დღესასწაულების ან ამინდის გამო.',
    ],
  },
  {
    id: 'size',
    title: 'ზომები და პროდუქციის აღწერა',
    items: [
      'ზომების ცხრილი ეყრდნობა ბავშვის ასაკსა და სიმაღლეს. საუკეთესო შედეგისთვის გაზომეთ ბავშვი და შეადარეთ ცხრილს.',
      'პროდუქციის ფერი შეიძლება ოდნავ განსხვავდებოდეს ეკრანზე ნანახისგან, რაც დამოკიდებულია თქვენი მოწყობილობის პარამეტრებზე.',
    ],
  },
  {
    id: 'returns',
    title: 'დაბრუნება და გაცვლა',
    items: [
      'პროდუქციის დაბრუნება შესაძლებელია მიღებიდან 2 კალენდარული დღის განმავლობაში. გაცვლა შესაძლებელია 14 კალენდარული დღის განმავლობაში.',
      'პროდუქცია უნდა იყოს გამოუყენებელი, გაურეცხავი, ეტიკეტებითა და ორიგინალი შეფუთვით.',
      'ჰიგიენური მიზეზების გამო დაბრუნებას არ ექვემდებარება საცვლები, წინდები და სხვა პირადი ჰიგიენის ნაწარმი.',
      'თანხა უბრუნდება იმავე გზით, რომლითაც გადაიხადეთ, პროდუქციის დაბრუნებიდან 14 დღის ვადაში.',
      'თუ პროდუქციას ხარვეზი აქვს, დაბრუნების ხარჯს ვფარავთ ჩვენ. თუ უბრალოდ გადაწყვიტეთ, რომ არ გჭირდებათ, დაბრუნების ხარჯი მყიდველს ეკისრება.',
    ],
  },
  {
    id: 'quality',
    title: 'ხარისხი და გარანტია',
    items: [
      'ჩვენი პროდუქცია შეესაბამება ბავშვთა ტექსტილისთვის დადგენილ უსაფრთხოებისა და ხარისხის მოთხოვნებს.',
      'ხარვეზის აღმოჩენისას დაგვიკავშირდით და გამოგვიგზავნეთ ფოტო. პროდუქციას შევცვლით ან თანხას დაგიბრუნებთ.',
      'რეცხვისა და მოვლის ინსტრუქცია მითითებულია ეტიკეტზე. არასწორი მოვლით გამოწვეული დაზიანება გარანტიას არ ექვემდებარება.',
    ],
  },
  {
    id: 'privacy',
    title: 'პერსონალური მონაცემები',
    items: [
      'შეკვეთის შესასრულებლად ვაგროვებთ თქვენს სახელს, ტელეფონის ნომერს, ელფოსტას და მისამართს.',
      'თქვენს მონაცემებს არ გადავცემთ მესამე პირებს, გარდა კურიერისა და გადახდის მომსახურების მიმწოდებლისა, რაც შეკვეთის შესასრულებლად აუცილებელია.',
      'საქართველოს კანონმდებლობის შესაბამისად, გაქვთ უფლება მოითხოვოთ თქვენი მონაცემების ნახვა, შესწორება ან წაშლა. ამისთვის მოგვწერეთ ქვემოთ მითითებულ ელფოსტაზე.',
    ],
  },
  {
    id: 'ip',
    title: 'ინტელექტუალური საკუთრება',
    items: [
      'ვებგვერდზე განთავსებული ტექსტები, ფოტოები, ლოგო და დიზაინი მაღაზიის საკუთრებაა.',
      'მათი კოპირება, გავრცელება ან კომერციული გამოყენება მაღაზიის წერილობითი თანხმობის გარეშე აკრძალულია.',
    ],
  },
  {
    id: 'liability',
    title: 'პასუხისმგებლობა',
    items: [
      'ვცდილობთ, ვებგვერდზე არსებული ინფორმაცია იყოს ზუსტი. ფასის ან აღწერის ტექნიკური შეცდომის აღმოჩენისას მაღაზიას უფლება აქვს გამოასწოროს იგი და, საჭიროების შემთხვევაში, გააუქმოს შეკვეთა გადახდილი თანხის სრული დაბრუნებით.',
      'მაღაზია არ აგებს პასუხს ვალდებულების შეუსრულებლობაზე, თუ ის გამოწვეულია გადაულახავი ძალით (ფორს-მაჟორით).',
    ],
  },
  {
    id: 'changes',
    title: 'პირობების ცვლილება',
    items: [
      'მაღაზია იტოვებს უფლებას, ნებისმიერ დროს შეცვალოს წინამდებარე პირობები. განახლებული ვერსია ქვეყნდება ამავე გვერდზე და მოქმედებას იწყებს გამოქვეყნებისთანავე.',
      'უკვე გაფორმებულ შეკვეთებზე ვრცელდება შეკვეთის გაფორმებისას მოქმედი პირობები.',
    ],
  },
  {
    id: 'disputes',
    title: 'დავების გადაწყვეტა',
    items: [
      'ნებისმიერ უთანხმოებას პირველ რიგში შევეცდებით გადავწყვიტოთ მოლაპარაკებით.',
      'თუ შეთანხმება ვერ მოხერხდა, დავა განიხილება საქართველოს მოქმედი კანონმდებლობის შესაბამისად, საქართველოს სასამართლოში.',
    ],
  },
];

const contacts = [
  { label: 'ელფოსტა', value: 'shop@kid-o.ge' },
  { label: 'ტელეფონი', value: '+995 599 01 15 72' },
  { label: 'სამუშაო საათები', value: 'ორშაბათი–შაბათი, 10:00–19:00' },
];

const allSections = [...sections, { id: 'contact', title: 'საკონტაქტო ინფორმაცია' }];

export default function TermsPage() {
  const [active, setActive] = useState(allSections[0].id);

  // highlight the section currently in view
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setActive(e.target.id);
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );
    allSections.forEach((s) => {
      const el = document.getElementById(s.id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  return (
    <main className="terms-page">
      <header className="terms-hero">
        <div className="terms-sun" aria-hidden="true" />
        <div className="terms-hero-inner">
          <h1>წესები და პირობები</h1>
          <p className="terms-updated">ბოლო განახლება: {LAST_UPDATED}</p>
          <ul className="terms-facts">
            {facts.map((f) => (
              <li key={f.big}>
                <strong>{f.big}</strong>
                <span>{f.small}</span>
              </li>
            ))}
          </ul>
        </div>
      </header>

      <div className="terms-layout">
        <nav className="terms-toc" aria-label="სარჩევი">
          <ol>
            {allSections.map((s, i) => (
              <li key={s.id}>
                <a
                  href={`#${s.id}`}
                  className={active === s.id ? 'active' : ''}
                  aria-current={active === s.id ? 'true' : undefined}
                >
                  <span className="terms-toc-num">{i + 1}</span>
                  {s.title}
                </a>
              </li>
            ))}
          </ol>
        </nav>

        <article className="terms-content">
          {sections.map((s, i) => (
            <section key={s.id} id={s.id} className="terms-section">
              <h2>
                <span className="terms-num">{i + 1}</span>
                {s.title}
              </h2>
              <ul>
                {s.items.map((text, j) => (
                  <li key={j}>{text}</li>
                ))}
              </ul>
            </section>
          ))}

          <section id="contact" className="terms-section terms-contact">
            <h2>
              <span className="terms-num">{allSections.length}</span>
              საკონტაქტო ინფორმაცია
            </h2>
            <p>კითხვების ან პრობლემის შემთხვევაში დაგვიკავშირდით:</p>
            <dl>
              {contacts.map((c) => (
                <div key={c.label}>
                  <dt>{c.label}</dt>
                  <dd>{c.value}</dd>
                </div>
              ))}
            </dl>
          </section>
        </article>
      </div>
    </main>
  );
}